import {createPopper} from '@popperjs/core';
import {getCitationUrl} from './textFragment.js';
import './popper.js';

const widget = document.getElementById('citationWidget') || document.querySelector('.js-citationSection');
const originalUrl = `${location.origin}${location.pathname}`;
let fullCitationUrl = originalUrl;

const elements = {
    fullLinkCheckbox: widget.querySelector('#citationFullLink'),
    fullLinkContainer: widget.querySelector('#citationFullLinkContainer'),
    formatSelect: widget.querySelector('#citationFormat'),
    pop: document.querySelector('.js-pop'),
    copyButton: widget.querySelector('.js-citationCopyButton'),
    citeArticleButtons: document.querySelectorAll('.js-citationButton'),
    referenceUrls: widget.querySelectorAll('.js-referenceUrl'),
    inlineNotification: widget.querySelector('.js-inlineNotification'),
};

/** Event listeners */
widget.addEventListener('open', handleCitationFormatChange); // reset citation text
elements.citeArticleButtons.forEach((/** @type {HTMLElement} */ citationButton) => citationButton.addEventListener('click', handleCiteThisArticleButtonClick));
elements.fullLinkCheckbox?.addEventListener('change', updateCitationUrlInWidget);
elements.formatSelect.addEventListener('change', handleCitationFormatChange);
elements.pop.addEventListener('click', handleCitationTooltipClick);
elements.copyButton.addEventListener('click', handleCopyButtonClick);

/**
 * @param {Event} clickEvent
 */
function handleCiteThisArticleButtonClick(/** @type {Event} */ clickEvent) {
    clickEvent.preventDefault();
    fullCitationUrl = originalUrl;
    elements.fullLinkContainer.classList.add('hidden');
    updateCitationUrlInWidget();
}

/**
 * @param {Event} event
 * @returns {void}
 */
function handleCopyButtonClick(event) {
    event.preventDefault();
    const citationText = document.getElementById(elements.formatSelect.value).textContent.trim().replaceAll(/\s+/g, ' ');
    navigator.clipboard.writeText(citationText);

    /** Display copied to clipboard tooltip and make it disappear after 3 seconds */
    elements.inlineNotification.classList.remove('hidden');
    createPopper(elements.copyButton, elements.inlineNotification, {
        placement: 'top',
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [0, 8],
                },
            },
        ],
    });

    setTimeout(function() {
        // Clear the text after 3 seconds
        elements.inlineNotification.classList.add('hidden');
    }, 3000);
}

/** Switch between different citation styles (APA, MLA, IEEE, ACM>). */
function handleCitationFormatChange() {
    document.querySelectorAll('.js-citationText').forEach((citation) => {
        citation.classList.add('hidden');
    });
    document.getElementById(elements.formatSelect.value).classList.remove('hidden');
}

/** Handle the click on the "Cite this page" tooltip. */
function handleCitationTooltipClick() {
    fullCitationUrl = getCitationUrl(document.getSelection());
    elements.fullLinkContainer.classList.remove('hidden');
    updateCitationUrlInWidget();
}

/** Update the citation URL in the widget depending on the "Cite selection" checkbox state. */
function updateCitationUrlInWidget() {
    const url = elements.fullLinkCheckbox.checked ? fullCitationUrl : originalUrl;
    document.querySelectorAll('.js-referenceUrl').forEach((item) => {
        item.innerHTML = url;
    });
}
